import EditionHomePage from './edition/EditionHomePage';
import AtelierHomePage from './atelier/AtelierHomePage';
import GalleryHomePage from './gallery/GalleryHomePage';

/**
 * Maps a sellable theme to its purpose-built storefront renderer.
 *
 * Legacy themes deliberately do not appear here: they continue through the
 * section registry in ThemedHomePage. That makes the new collection an
 * additive rollout rather than a visual migration for existing merchants.
 */
const themeRenderers = {
  edition: {
    HomePage: EditionHomePage,
  },
  atelier: {
    HomePage: AtelierHomePage,
  },
  gallery: {
    HomePage: GalleryHomePage,
  },
};

export function getThemeRenderer(theme) {
  return themeRenderers[theme?.slug] || null;
}
